(function () {
  const activeSubmissions = new WeakSet();

  const selectors = {
    root: 'optional-product-addons',
    group: '[data-optional-addon-group]',
    selectedRadio: 'input[type="radio"][data-addon-variant-id]:checked',
    selectedOption: 'select[data-optional-addon-select]',
    configuredPrice: '[data-addon-configured-price]',
    configuredPriceValue: '[data-addon-configured-price-value]',
    variantPrices: '[data-addon-variant-prices]',
    groupError: '[data-addon-group-error]',
    proxyButton: '[data-addon-atc-proxy]',
  };

  function getSelectedElement(group) {
    const selectedRadio = group.querySelector(selectors.selectedRadio);
    if (selectedRadio) return selectedRadio;

    const select = group.querySelector(selectors.selectedOption);
    const selectedOption = select?.selectedOptions?.[0];
    return selectedOption?.dataset?.addonVariantId ? selectedOption : null;
  }


  function getSelectedAddons(root) {
    return Array.from(root.querySelectorAll(selectors.group))
      .map((group, index) => {
        const selected = getSelectedElement(group);
        if (!selected || selected.disabled || !selected.dataset.addonVariantId) return null;

        return {
          id: Number(selected.dataset.addonVariantId),
          productId: selected.dataset.addonProductId || '',
          sku: selected.dataset.addonVariantSku || '',
          title: selected.dataset.addonVariantTitle || '',
          groupTitle: group.dataset.addonGroupTitle || '',
          groupHandle: group.dataset.addonGroupHandle || '',
          groupRequired: group.dataset.addonRequired === 'true',
          groupIndex: group.dataset.addonGroupIndex || String(index + 1),
          quantityBehavior: group.dataset.quantityBehavior || 'same_as_parent',
          sourceOptionSetId: group.dataset.sourceOptionSetId || '',
          sourceOptionId: group.dataset.sourceOptionId || '',
          price: Number(selected.dataset.addonPrice || 0),
        };
      })
      .filter(Boolean);
  }

  function hasRequiredGroups(root) {
    return Boolean(root.querySelector(`${selectors.group}[data-addon-required="true"]`));
  }

  function setGroupError(group, hasError) {
    group.classList.toggle('has-error', hasError);
    group.querySelector(selectors.groupError)?.toggleAttribute('hidden', !hasError);
  }

  function validateRequiredGroups(root) {
    const missingGroups = Array.from(root.querySelectorAll(`${selectors.group}[data-addon-required="true"]`)).filter(
      (group) => {
        const selected = getSelectedElement(group);
        const isMissing = !selected || selected.disabled || !selected.dataset.addonVariantId;
        setGroupError(group, isMissing);
        return isMissing;
      }
    );

    return {
      valid: missingGroups.length === 0,
      missingGroups,
    };
  }

  function clearGroupError(event) {
    const group = event.target?.closest?.(selectors.group);
    if (!group) return;
    setGroupError(group, false);
  }

  function getQuantity(form) {
    const quantityInput = form.querySelector('[name="quantity"]');
    const quantity = parseInt(quantityInput?.value, 10);
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }

  function getLineItemProperties(form) {
    const properties = {};
    const formData = new FormData(form);

    formData.forEach((value, key) => {
      const match = key.match(/^properties\[(.+)\]$/);
      if (!match || value === '') return;
      properties[match[1]] = value;
    });

    return properties;
  }

  function getSellingPlan(form) {
    const sellingPlanInput = form.querySelector('[name="selling_plan"]');
    return sellingPlanInput?.value || '';
  }

    function getVariantPrices(root) {
    if (root._addonVariantPrices) return root._addonVariantPrices;

    try {
      root._addonVariantPrices = JSON.parse(root.querySelector(selectors.variantPrices)?.textContent || '{}');
    } catch (error) {
      root._addonVariantPrices = {};
    }

    return root._addonVariantPrices;
  }

  function formatMoney(cents) {
    const format = window.FoxTheme?.settings?.moneyFormat;
    if (window.FoxTheme?.Currency?.formatMoney) return window.FoxTheme.Currency.formatMoney(cents, format);

    return (cents / 100).toLocaleString(undefined, {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'USD',
    });
  }

  function getCoreVariantPrice(form, root) {
    const coreVariantId = form.querySelector('[name="id"]')?.value;
    const prices = getVariantPrices(root);
    return Number(prices[coreVariantId] || 0);
  }

  function updateConfiguredPrice(root) {
    const form = root.closest('form[is="product-form"]');
    const priceWrap = root.querySelector(selectors.configuredPrice);
    const priceValue = root.querySelector(selectors.configuredPriceValue);
    if (!form || !priceWrap || !priceValue) return;

    const selectedAddons = getSelectedAddons(root);
    const addonPrice = selectedAddons.reduce((total, addon) => total + addon.price, 0);
    const totalPrice = getCoreVariantPrice(form, root) + addonPrice;

    priceValue.textContent = formatMoney(totalPrice);
    priceWrap.hidden = totalPrice <= 0;
  }

  function getParentSku(root) {
    const skuElement = document
      .getElementById(`Sku-${root.dataset.sectionId}`)
      ?.querySelector('[data-product-meta-value="sku"]');

    return skuElement?.textContent?.trim() || '';
  }

  function getSectionsToBundle() {
    const sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections } })
    );
    return sections;
  }

  function setButtonLoading(button, isLoading) {
    if (!button) return;

    if (isLoading) {
      button.setAttribute('aria-disabled', 'true');
    } else {
      button.removeAttribute('aria-disabled');
    }
    button.classList.toggle('btn--loading', isLoading);
  }

  function displayFormErrors(form, message = false) {
    if (typeof form.displayFormErrors === 'function') {
      form.displayFormErrors(message);
      return;
    }

    const errorMessage = form.querySelector('.product-form__error-message');
    if (!errorMessage) {
      if (message !== false) alert(message);
      return;
    }

    errorMessage.toggleAttribute('hidden', !message);
    if (message !== false) errorMessage.innerText = message;
  }

  function reportMissingGroups(form, validation, button) {
    const firstMissingGroup = validation.missingGroups[0];
    const groupTitle = firstMissingGroup?.dataset?.addonGroupTitle || 'the required option';

    displayFormErrors(form, `Please select an option for ${groupTitle}.`);
    setButtonLoading(button, false);
    firstMissingGroup?.scrollIntoView?.({ behavior: 'smooth', block: 'center' });
    firstMissingGroup?.querySelector?.('input:not(:disabled), select:not(:disabled)')?.focus?.();
  }

  function publishCartUpdate(cartJson) {
    window.FoxTheme?.pubsub?.publish(window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
  }

  function publishCartError(form, coreVariantId, parsedState) {
    window.FoxTheme?.pubsub?.publish(window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartError, {
      source: 'optional-product-addons',
      productVariantId: coreVariantId,
      errors: parsedState.errors || parsedState.description,
      message: parsedState.message,
    });

    document.dispatchEvent(
      new CustomEvent('product-ajax:error', {
        detail: {
          errorMessage: parsedState.description,
        },
      })
    );

    displayFormErrors(form, parsedState.description || parsedState.message || window.FoxTheme?.cartStrings?.error);
  }

  function showCartDrawer(focusElement) {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;
    cartDrawer.show(focusElement);
  }

  async function submitAddons(form, root, selectedAddons, submitButton) {
    const coreVariantId = form.querySelector('[name="id"]')?.value;
    if (!coreVariantId) return;

    const quantity = getQuantity(form);
    const parentSku = getParentSku(root);
    const parentProductId = root.dataset.parentProductId || '';
    const parentProductHandle = root.dataset.parentProductHandle || '';
    const parentProductTitle = root.dataset.parentProductTitle || '';
    const sections = getSectionsToBundle();
    const sellingPlan = getSellingPlan(form);
    const coreProperties = getLineItemProperties(form);

    const coreItem = {
      id: Number(coreVariantId),
      quantity,
    };

    if (sellingPlan) coreItem.selling_plan = Number(sellingPlan);
    if (Object.keys(coreProperties).length) coreItem.properties = coreProperties;

    const addonItems = selectedAddons.map((addon) => ({
      id: addon.id,
      quantity: ['always_one', 'fixed_one'].includes(addon.quantityBehavior) ? 1 : quantity,
      properties: {
        _addon_for_product_id: parentProductId,
        _addon_for_variant_id: String(coreVariantId),
        _addon_for_sku: parentSku,
        _addon_parent_product_handle: parentProductHandle,
        _addon_group_required: addon.groupRequired ? 'true' : 'false',
        _addon_group_index: addon.groupIndex,
        _addon_parent_product_title: parentProductTitle,
        _addon_group: addon.groupTitle,
        _addon_group_handle: addon.groupHandle,
        _bc_option_set_id: addon.sourceOptionSetId,
        _bc_option_id: addon.sourceOptionId,
      },
    }));

    const body = {
      items: [coreItem, ...addonItems],
      sections,
      sections_url: window.location.pathname,
    };

    const config = window.FoxTheme?.utils?.fetchConfig
      ? window.FoxTheme.utils.fetchConfig('javascript')
      : { method: 'POST', headers: { Accept: 'application/javascript', 'Content-Type': 'application/json' } };

    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    config.headers['Content-Type'] = 'application/json';
    config.body = JSON.stringify(body);

    setButtonLoading(submitButton, true);
    displayFormErrors(form);

    try {
      const response = await fetch(window.FoxTheme?.routes?.cart_add_url || '/cart/add.js', config);
      const parsedState = await response.json();

      if (parsedState.status) {
        publishCartError(form, coreVariantId, parsedState);
        return;
      }

      const cartResponse = await fetch(window.FoxTheme?.routes?.cart_url || '/cart.js', {
        ...(window.FoxTheme?.utils?.fetchConfig ? window.FoxTheme.utils.fetchConfig('json', 'GET') : { method: 'GET' }),
      });
      const cartJson = await cartResponse.json();
      cartJson.sections = parsedState.sections;

      publishCartUpdate(cartJson);

      document.dispatchEvent(
        new CustomEvent('product-ajax:added', {
          detail: {
            product: parsedState,
          },
        })
      );

      if (window.FoxTheme?.settings?.cartType === 'page') {
        window.location.href = window.FoxTheme?.routes?.cart_url || '/cart';
      } else {
        showCartDrawer(submitButton);
      }
    } catch (error) {
      console.error(error);
      displayFormErrors(form, window.FoxTheme?.cartStrings?.error || 'There was an error adding this item to the cart.');
    } finally {
      activeSubmissions.delete(form);
      setButtonLoading(submitButton, false);
    }
  }

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!form?.matches?.('form[is="product-form"]')) return;

      const root = form.querySelector(selectors.root);
      if (!root) return;

      const selectedAddons = getSelectedAddons(root);

      const shouldOwnSubmit = selectedAddons.length > 0 || hasRequiredGroups(root);
      if (!shouldOwnSubmit) return;

      const submitButton = event.submitter || form.querySelector('[type="submit"]');
      if (activeSubmissions.has(form)) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      const validation = validateRequiredGroups(root);
      if (!validation.valid) {
        reportMissingGroups(form, validation, submitButton);
        return;
      }
      
      activeSubmissions.add(form);
      submitAddons(form, root, selectedAddons, submitButton);
    },
    true
  );
  document.addEventListener('change', (event) => {
    const root = event.target?.closest?.(selectors.root);
    if (!root) return;
    clearGroupError(event);
    updateConfiguredPrice(root);
  });

  document.querySelectorAll(selectors.root).forEach((root) => {
    const form = root.closest('form[is="product-form"]');
    const variantInput = form?.querySelector('[name="id"]');
    updateConfiguredPrice(root);

    if (!variantInput) return;
    new MutationObserver(() => updateConfiguredPrice(root)).observe(variantInput, {
      attributes: true,
      attributeFilter: ['value'],
    });
    variantInput.addEventListener('change', () => updateConfiguredPrice(root));
  });

  // Add-to-cart buttons that live outside the product form (the sticky bar) submit
  // the parent variant on their own and drop the add-ons, so they opt out of being
  // submit buttons and route through this handler instead.
  document.addEventListener(
    'click',
    (event) => {
      const proxyButton = event.target?.closest?.(selectors.proxyButton);
      if (!proxyButton) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (proxyButton.disabled || proxyButton.getAttribute('aria-disabled') === 'true') return;

      const form = document.getElementById(proxyButton.dataset.addonAtcProxy);
      const root = form?.querySelector(selectors.root);
      if (!form || !root || activeSubmissions.has(form)) return;

      const validation = validateRequiredGroups(root);
      if (!validation.valid) {
        reportMissingGroups(form, validation, proxyButton);
        return;
      }

      activeSubmissions.add(form);
      submitAddons(form, root, getSelectedAddons(root), proxyButton);
    },
    true
  );

  document.querySelectorAll(selectors.proxyButton).forEach((proxyButton) => {
    const form = document.getElementById(proxyButton.dataset.addonAtcProxy);
    const formButton = form?.querySelector('[type="submit"][name="add"]');
    if (!formButton) return;

    const syncDisabledState = () => {
      proxyButton.disabled = formButton.disabled;
    };

    syncDisabledState();
    new MutationObserver(syncDisabledState).observe(formButton, {
      attributes: true,
      attributeFilter: ['disabled'],
    });
  });

  document.addEventListener('variant:changed', (event) => {
    const sectionId = event.detail?.sectionId || event.detail?.variant?.sectionId;
    document.querySelectorAll(selectors.root).forEach((root) => {
      if (!sectionId || root.dataset.sectionId === sectionId) updateConfiguredPrice(root);
    });
  });
})();